import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print-advanced";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { getUnOrderedPrescription } from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import { ERROR } from "../../constants/types/alertType";
import {
  constructDisplayText,
  formatDecimal,
  getUserDetail,
} from "../../utils/helper";
import history from "../../utils/history";
import { getPrescriptionFormSettings } from "../../actions/settingsActions";
const UnorderedPrescriptionDetailPopup = ({
  closePopup,
  prescriptionId,
  date,
}) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const [singleHerbs, setSingleHerb] = useState([]);
  const [formulaHerbs, setFormulaHerb] = useState([]);
  const [prepCost, setPrepCost] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const cartItems = useSelector((state) => state.cart.activeCartItem);
  const [loading, setLoading] = useState(true);
  const orderedPrescription = useSelector(
    (state) => state.prescription.unorderedPrescription
  );
  const [originalTitle, setOriginalTitle] = useState(document.title);
  const role = useSelector((state) => state.role.role);
  const [preparationMethods, setPreparationMethods] = useState(null);
  useEffect(() => {
    dispatch(
      getPrescriptionFormSettings((preparationMethods) => {
        setPreparationMethods(preparationMethods);
        dispatch(
          getUnOrderedPrescription(prescriptionId, () => {
            setLoading(false);
          })
        );
      })
    );
  }, [dispatch]);

  const getDosage = (dosage) => {
    let value = parseFloat(dosage);
    let price = orderedPrescription?.Dosage_Type === 0 ? value : value;
    return Math.round(price * 100) / 100;
  };

  const addItemToCart = () => {
    let oldItem = cartItems.find(
      (x) =>
        x.prescriptionId == orderedPrescription.Prescription_ID &&
        x.itemType == 1
    );
    if (oldItem) {
      dispatch({
        type: ERROR,
        payload: "Item is already in your cart",
      });
      return;
    }
    cartItems.some((item) => {
      let isRaw = orderedPrescription?.Dosage_Type === 0;
      let itemType = isRaw ? 0 : 1;
      if (item.dosageType != itemType) {
        dispatch({
          type: ERROR,
          payload: ` You already have a ${isRaw ? "Granular" : "Raw"
            } type prescription in your cart. To add a ${isRaw ? "Raw" : "Granular"
            } type instead, please remove the ${isRaw ? "Granular" : "Raw"
            } one first.`,
        });
        return;
      }
    });

    closePopup();
    let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
    var params = {
      params: {
        action: "addCartItem",
        itemId: orderedPrescription.Prescription_ID,
        itemType: 1,
        quantity: 1,
        roleId: roleId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getPatientNotification(role.val));
        history.push("/app/shopping");
      })
    );
  };

  useEffect(() => {
    if (orderedPrescription.Herbs?.length > 0) {
      let singleHerbItems = [];
      let formulaHerbItems = [];
      let formulaTableData = [];
      var total_size_edit = 0;
      orderedPrescription?.Herbs.forEach((x) => {
        total_size_edit = total_size_edit + parseFloat(x.dosage);
        if (x.form_display) {
          formulaHerbItems.push(x);
        } else {
          singleHerbItems.push(x);
        }
      });
      setTotalWeight(total_size_edit);
      var formulaId = 0;
      var modificationId = 0;
      for (let i = 0; i < formulaHerbItems.length; i++) {
        if (formulaId !== formulaHerbItems[i].form_id) {
          formulaId = formulaHerbItems[i].form_id;
          formulaTableData.push(
            <>
              <tr
                className="herb-title"
                key={formulaHerbItems[i].herb_id + "title"}
              >
                <td>{formulaHerbItems[i].form_display}</td>
              </tr>
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  <p
                    style={{ marginBottom: 0 }}
                    className={`${formulaHerbItems[i].herb_id == 0
                      ? "sunten-formula-fix"
                      : ""
                      }`}
                  >
                    {getDosage(formulaHerbItems[i].dosage)?.toLocaleString(
                      "en-US",
                      {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1,
                      }
                    )}
                  </p>
                </td>
                <td></td>
              </tr>
            </>
          );
        } else {
          if (modificationId !== formulaHerbItems[i].mod_id) {
            modificationId = formulaHerbItems[i].mod_id;
            formulaTableData.push(
              <>
                <tr
                  className="herb-title"
                  key={formulaHerbItems[i].herb_id + "title"}
                >
                  <td>{formulaHerbItems[i].mod_display}</td>
                </tr>
                <tr key={formulaHerbItems[i].herb_id}>
                  <td>
                    {constructDisplayText(
                      formulaHerbItems[i].herb_display,
                      formulaHerbItems[i].HERB_Latin_Name,
                      formulaHerbItems[i].HERB_Chinese_Name,
                      formulaHerbItems[i].INV_ID_Granular
                    )}
                  </td>
                  <td className="text-right">
                    <p
                      style={{ marginBottom: 0 }}
                      className={`${formulaHerbItems[i].herb_id == 0
                        ? "sunten-formula-fix"
                        : ""
                        }`}
                    >
                      {getDosage(formulaHerbItems[i].dosage)?.toLocaleString(
                        "en-US",
                        {
                          maximumFractionDigits: 1,
                          minimumFractionDigits: 1,
                        }
                      )}
                    </p>
                  </td>
                  <td></td>
                </tr>
              </>
            );
          } else {
            formulaTableData.push(
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  {getDosage(formulaHerbItems[i].dosage)?.toFixed(1)}
                </td>
                <td></td>
              </tr>
            );
          }
        }
      }
      setSingleHerb(singleHerbItems);
      setFormulaHerb(formulaTableData);

      let prepValue = 0;

      let prepMethod = preparationMethods?.find(
        (x) => x.id == orderedPrescription.PRSC_Prep_Method
      );
      if (prepMethod) {
        if (!prepMethod.isRaw) {
          prepValue =
            Math.ceil(total_size_edit / prepMethod.perUnitQuantity) *
            prepMethod.preparationValue;
        } else {
          prepValue =
            prepMethod.preparationValue *
            parseFloat(orderedPrescription.PRSC_Serving_Total);
        }
        setPrepCost(prepValue);
      }
    }
  }, [orderedPrescription]);

  return (
    <>
      {!loading ? (
        <Modal size="xl" show={true} id="prescription-popup">
          <Modal.Body>
            <>
              <div className="prescription-detail">
                <div className="close-btn">
                  <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
                </div>
                {orderedPrescription && (
                  <>
                    <div className="inner-section">
                      <div className="row">
                        <div className="col-md-6">
                          <h2 className="heading">Prescription</h2>
                          <p className="desc">
                            You can order your prescription or print using the buttons at the bottom.
                          </p>
                        </div>
                      </div>
                      <div className="item-section" ref={componentRef}>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-6 reduce-height">
                                <h5>Practitioner:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>{orderedPrescription?.Practitioner_Name}</p>
                              </div>

                              <div className="col-md-6 reduce-height">
                                <h5>Patient:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>
                                  {getUserDetail()?.firstName}{" "}
                                  {getUserDetail()?.lastName}
                                </p>
                              </div>

                              <div className="col-md-6 reduce-height">
                                <h5>Date:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>{date}</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 icon">
                            <img src={RxIcon} />
                          </div>
                        </div>
                        <div className="formula-table mt-4">
                          <table className="table table_review">
                            <thead>
                              <tr>
                                <th>FORMULA(S) &amp; HERB(S)</th>
                                <th className="text-right">GRAMS</th>
                                <th className="text-right">PRICE</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formulaHerbs.length > 0 && formulaHerbs}
                              {singleHerbs.length > 0 && (
                                <>
                                  <tr className="herb-title">
                                    <td>Single Herbs</td>
                                  </tr>
                                  {singleHerbs.map((x) => {
                                    return (
                                      <tr key={x.herb_id}>
                                        <td>
                                          {constructDisplayText(
                                            x.herb_display,
                                            x.HERB_Latin_Name,
                                            x.HERB_Chinese_Name,
                                            x.INV_ID_Granular
                                          )}
                                        </td>
                                        <td className="text-right">
                                          {getDosage(x.dosage)?.toFixed(1)}
                                        </td>
                                        <td></td>
                                      </tr>
                                    );
                                  })}
                                </>
                              )}
                              <tr key="total">
                                <td className="total">Total</td>
                                <td className="d-flex justify-content-end total">
                                  <p className="hr-replacement">
                                    {totalWeight.toLocaleString("en-US", {
                                      maximumFractionDigits: 1,
                                      minimumFractionDigits: 1,
                                    })}
                                  </p>
                                </td>
                                <td className="text-right total">
                                  <div className="d-flex justify-content-end">
                                    <p className="hr-replacement">
                                      {`${(
                                        Math.round(
                                          (orderedPrescription?.Total_Price /
                                            100) *
                                          100
                                        ) / 100
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                        style: "currency",
                                        currency: "USD",
                                      })}  
                            `}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="serving-section">
                          {orderedPrescription?.Serving_Amount == 0 ||
                            orderedPrescription?.Serving_Per_Day == 0 ||
                            orderedPrescription?.Serving_Days == 0 ? (
                            ""
                          ) : (
                            <>
                              <h3>Serving Instructions</h3>
                              {orderedPrescription?.Dosage_Type === 0 ? (
                                <p>
                                  {orderedPrescription?.Serving_Per_Day}{" "}
                                  packet(s) a day for{" "}
                                  {orderedPrescription?.Serving_Days} day(s)
                                </p>
                              ) : (
                                <p>
                                  {formatDecimal(
                                    orderedPrescription?.Serving_Amount
                                  )}{" "}
                                  scoop(s),{" "}
                                  {formatDecimal(
                                    orderedPrescription?.Serving_Per_Day
                                  )}{" "}
                                  times a day(s) for{" "}
                                  {orderedPrescription?.Serving_Days} day(s)
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="btn-section">
                      <div className="row">
                        <div className="col-md-10 pl-5">
                          <ReactToPrint
                            trigger={() => (
                              <button className="btn-orange">PRINT</button>
                            )}
                            content={() => componentRef.current}
                            onBeforePrint={() => {
                              document.title = `Prescription #${orderedPrescription?.Prescription_ID} from ${orderedPrescription?.Practitioner_Name}`;
                            }}
                            onAfterPrint={() => {
                              document.title = originalTitle || "MyHerbPharm";
                            }}
                          />
                        </div>
                        <div className="col-md-2">
                          <button
                            className="btn-orange"
                            onClick={() => {
                              addItemToCart();
                            }}
                          >
                            ORDER
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};
export default UnorderedPrescriptionDetailPopup;
